import { Link } from "react-router-dom";
import { Heart } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { useState, useEffect } from "react";
import StarRating from "./StarRating";

export default function ProductCard({ product, index = 0 }) {
  const { user, setUser } = useAuth();
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    if (user?.wishlist) setLiked(user.wishlist.includes(product.id));
  }, [user, product.id]);

  const toggle = async (e) => {
    e.preventDefault();
    if (!user) return toast.error("Please sign in to save favourites");
    try {
      const { data } = await api.post("/wishlist/toggle", { product_id: product.id });
      setUser({ ...user, wishlist: data.wishlist });
      setLiked(data.wishlist.includes(product.id));
    } catch { toast.error("Something went wrong"); }
  };

  return (
    <Link to={`/product/${product.slug}`} className="product-card block group fade-up" style={{ animationDelay: `${index * 60}ms` }} data-testid={`product-card-${product.slug}`}>
      <div className="relative aspect-[3/4] bg-[#F0EBE1] overflow-hidden mb-4">
        <img src={product.images[0]} alt={product.name} className="img-primary absolute inset-0 w-full h-full object-cover" loading="lazy" />
        {product.images[1] && (
          <img src={product.images[1]} alt={product.name + " alt"} className="img-secondary absolute inset-0 w-full h-full object-cover" loading="lazy" />
        )}
        <button onClick={toggle} className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-[#FAF8F5]/80 backdrop-blur-sm hover:bg-[#FAF8F5]" data-testid={`wishlist-toggle-${product.slug}`} aria-label="Save">
          <Heart size={16} weight={liked ? "fill" : "light"} color={liked ? "#4A1525" : "#1A1A1A"} />
        </button>
        {product.featured && (
          <span className="absolute top-4 left-4 overline bg-[#FAF8F5]/80 backdrop-blur-sm px-3 py-1 text-[#4A1525]" data-testid={`featured-badge-${product.slug}`}>New</span>
        )}
      </div>
      <div className="flex justify-between items-start gap-4">
        <div>
          <div className="font-serif text-lg text-[#1A1A1A] group-hover:text-[#4A1525] transition-colors">{product.name}</div>
          <div className="overline text-[#5C5C5C] mt-1">{product.category}</div>
          {product.review_count > 0 && (
            <div className="mt-2"><StarRating value={product.avg_rating} size={11} /></div>
          )}
        </div>
        <div className="text-sm text-[#1A1A1A]">₹{product.price.toFixed(0)}</div>
      </div>
    </Link>
  );
}
